var _defs, _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAnger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffa452;}.cls-2{fill:#363636;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-anger") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 500,
    cy: 500,
    r: 350
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M607.12,466.44a28.49,28.49,0,0,1-19.59-49.2c2-1.9,49.85-46.27,112.89-30.45a28.5,28.5,0,1,1-13.87,55.29C654,433.91,627,458.4,626.69,458.65A28.4,28.4,0,0,1,607.12,466.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.7,674.76a27.94,27.94,0,0,1-18-49.31c3.28-2.77,81.53-67.86,178.31-67.86s175,65.09,178.31,67.86a27.93,27.93,0,0,1-36,42.69c-.61-.51-66.29-54.69-142.29-54.69s-141.68,54.18-142.33,54.73A27.78,27.78,0,0,1,339.7,674.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M392.88,466.44a28.49,28.49,0,0,0,19.59-49.2c-2-1.9-49.85-46.27-112.89-30.45a28.5,28.5,0,1,0,13.87,55.29C346,433.91,373,458.4,373.31,458.65A28.4,28.4,0,0,0,392.88,466.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnger);
export default __webpack_public_path__ + "static/media/icon-anger.d82349ee0fdaf87000e2da6d35708575.svg";
export { ForwardRef as ReactComponent };